import moment from "moment";
import apiConfig from "@/config/apiConfig";
import {saveAs} from 'file-saver'
import {file_service} from '@/api/adminService';
import axios from "axios";
import {areaObject} from "@/utils/areaData";

export const formatNumber = n => {
    n = n.toString();
    return n[1] ? n : '0' + n
}
export const saveFile = (content, fileName) => {
    const blob = new Blob([content], {type: "text/plain;charset=utf-8"});
    saveAs(blob, fileName);
}


// 本地获取
export const getImg = (id) => {
    let arr = [];
    let picArr = [];
    if (id) {
        arr = id.split(',')
    }
    for (let i in arr) {
        axios({
            methods: 'get',
            url: i ? file_service.images(i) : "",

            responseType: 'blob',
            headers: {
                'content-type': 'application/x-www-form-urlencoded',
                Authorization: 'Bearer' + ls.get('token') || ''
            }
        }).then(data => {
            const blob = new Blob([data.data], { type: "application/vnd.ms-excel;charset=utf-8" });
            const url = window.URL.createObjectURL(blob);
            picArr.push(url)
        })
    }
    return picArr
}
export const timeFix = () => {
    const time = new Date()
    const hour = time.getHours()
    return hour < 9
        ? '早上好'
        : hour <= 11
            ? '上午好'
            : hour <= 13
                ? '中午好'
                : hour < 20
                    ? '下午好' : '晚上好';
}

export const ls = {
    options: {
        namespace: 'NuoYun_wenku_mp_',
    },
    set(name, value, expires = null) {
        if(value !== null){
            const stringifyValue = JSON.stringify({
                value,
                expires: expires !== null ? new Date().getTime() + expires : null,
            });
            localStorage.setItem(`${this.options.namespace}${name}`, stringifyValue);
        }else{
            console.log(value)
        }
    },
    get(name, def = null) {
        const item = localStorage.getItem(this.options.namespace + name);
        if (item !== null) {
            try {
                const data = JSON.parse(item);
                if (data.expires === null) {
                    return data.value;
                }
                if (data.expires >= new Date().getTime()) {
                    return data.value;
                }
                this.remove(name);
            } catch (err) {
                return def;
            }
        }
        return def;
    },
    remove(name) {
        return localStorage.removeItem(`${this.options.namespace}${name}`);
    },
    clear() {
        if (localStorage.length === 0) {
            return;
        }
        const removedKeys = [];
        for (let i = 0; i < localStorage.length; i++) {
            const key = localStorage.key(i);
            const regexp = new RegExp(`^${this.options.namespace}.+`, 'i');
            if (regexp.test(key) === false) {
                continue;
            }
            removedKeys.push(key);
        }
        Object.keys(removedKeys).forEach(key => {
            localStorage.removeItem(removedKeys[key]);
        })
    }
}
export const isObjectArray = (value) => {
    if (Object.prototype.toString.call(value) === "[object Array]") {
        return 'Array';
    } else if (Object.prototype.toString.call(value) === '[object Object]') {
        return 'Object';
    } else {
        window.console.log('value不是数组也不是对象');
    }
}
export const filterObj = (obj) => {
    if (!(typeof obj == 'object')) {
        return;
    }
    for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key) && (obj[key] == null || obj[key] === undefined || obj[key] === '')) {
            delete obj[key];
        }
    }
    return obj
}
export const getQueryString = (name) => {
    var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
    var r = window.location.search.substr(1).match(reg);
    if (r != null) {
        return unescape(r[2]);
    }
    return null;
}
export const momentFormat = (dateTime, format, dateFormat = null) => {
    return dateTime
        ? moment(dateTime, dateFormat).format(format || 'YYYY-MM-DD')
        : '';
}
export const decimal = (num) => {
    return num.toLocaleString('zh', {style: 'decimal'})
}
export const AMapLoad = () => {
    return new Promise((resolve) => {
        if (window.AMap) {
            resolve(window.AMap)
        } else {
            var url = 'https://webapi.amap.com/maps?v=1.4.15&key=b5fbdbc5609e7ff93a8d6b51c034cd0c&callback=onAMapLoad';
            var jsapi = document.createElement('script');
            jsapi.charset = 'utf-8';
            jsapi.src = url;
            document.head.appendChild(jsapi);
        }
        window.onAMapLoad = () => {
            resolve(window.AMap)
        }
    })
}
export const getFilePath = (id) => {
    return id ? apiConfig.qiniu_BaseUrl + id : "";
}

export const highlights = (obj, fieldName,defaultText) => {
    // 高亮字段值不存在则返回
    if(!obj.highlights || !obj.highlights[fieldName]) {
        return defaultText;
    }
    // 返回高亮标记的值，返回第一个
    let highText = obj.highlights[fieldName][0];

    return {
        children: <span v-html={highText}></span>
    }
}

export const showCity = (belong_province, belong_city, belong_area) => {
    let arr = [areaObject[belong_province], areaObject[belong_city], areaObject[belong_area]];
    let arrget = '';
    for(var index=0;index<arr.length;index++){
        arrget+=arr[index]
    }
    // return arr.join(' / ')
    return arrget
}


/**
 * @param {Function} func
 * @param {number} wait
 * @param {boolean} immediate
 * @return {*}
 */
export function debounce(func, wait, immediate) {
    let timeout, args, context, timestamp, result

    const later = function() {
        // 据上一次触发时间间隔
        const last = +new Date() - timestamp

        // 上次被包装函数被调用时间间隔 last 小于设定时间间隔 wait
        if (last < wait && last > 0) {
            timeout = setTimeout(later, wait - last)
        } else {
            timeout = null
            // 如果设定为immediate===true，因为开始边界已经调用过了此处无需调用
            if (!immediate) {
                result = func.apply(context, args)
                if (!timeout) context = args = null
            }
        }
    }

    return function(...args) {
        context = this
        timestamp = +new Date()
        const callNow = immediate && !timeout
        // 如果延时不存在，重新设定延时
        if (!timeout) timeout = setTimeout(later, wait)
        if (callNow) {
            result = func.apply(context, args)
            context = args = null
        }

        return result
    }
}
